import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashRestore } from '@fortawesome/free-solid-svg-icons';
import { RootState, useDispatch, useSelector } from '../../redux/store';
import { undoDeleteOrdinary } from '../../redux/slices/condition';
import { CONDITION_STATUS, MANAGE_CONDITION_TYPES } from '../../constants';
import type { ICellRendererParams } from 'ag-grid-community';
import type { ConditionDetailType, CreateConditionDetailParams } from '../../types/condition';

const UndoDeletedCondition = (params: ICellRendererParams): React.ReactElement => {
  const dispatch = useDispatch();
  const { condition, selectedViewMode } = useSelector((state: RootState) => state.condition);
  const data: ConditionDetailType = params.data;
  const isEditable = selectedViewMode === CONDITION_STATUS.EDITING && (condition?.conditionStatus === CONDITION_STATUS.EDITING || condition?.conditionStatus === CONDITION_STATUS.APPROVED);

  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log(data);
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * Undoボタンを押した時
   */
  const handleUndo = useCallback((): void => {
    // console.log(data);
    // console.log(isEditable, condition);
    if (isEditable && condition !== undefined) {
      const params: CreateConditionDetailParams = {
        conditionId: condition.id,
        isApproved: false,
        conditionType: MANAGE_CONDITION_TYPES.ORDINARY,
        customer: data.customer,
        deliveryLocation: data.deliveryLocation,
        updateCondition: {
          conditionStatus: CONDITION_STATUS.EDITING,
        },
      };
      // console.log(params);
      dispatch(undoDeleteOrdinary(params));
    } else {
      // do nothing
    }
  }, [isEditable, condition, data, dispatch]);

  // VIEW
  // ================================================================================

  return (
    <>
      <div id="undoActions">
        <>
          <FontAwesomeIcon
            className="mr-3"
            icon={faTrashRestore}
            size="lg"
            color={isEditable ? '#007bff' : '#ccc'}
            onClick={handleUndo}
            style={isEditable ? { cursor: 'pointer' } : { cursor: 'default' }}
          />
        </>
      </div>
    </>
  );
};

export default UndoDeletedCondition;
